import React, { useState } from "react";
import LanguageToggle from "./LanguageToggle";
import { useLanguage } from "../context/LanguageContext";

/**
 * Navigation bar component
 */
const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <nav className="bg-black text-white py-4 sticky top-0 z-50 border-b-0 mb-0">
      <div className="w-full flex justify-between items-center">
        <div className="pl-3">
          <img
            src="/Emanuel.svg"
            alt="Tudor Emanuel"
            className="h-12 md:h-16 w-auto"
          />
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex space-x-8 pr-10 items-center">
          <a
            href="#about"
            className="hover:text-yellow-400 transition font-medium tracking-wide"
          >
            {t('about')}
          </a>
          <a
            href="#coaching"
            className="hover:text-yellow-400 transition font-medium tracking-wide"
          >
            {t('coaching')}
          </a>
          <a
            href="#speaking"
            className="hover:text-yellow-400 transition font-medium tracking-wide"
          >
            {t('speaking')}
          </a>
          <a
            href="#testimonials"
            className="hover:text-yellow-400 transition font-medium tracking-wide"
          >
            {t('testimonials')}
          </a>
          <a
            href="#contact"
            className="hover:text-yellow-400 transition font-medium tracking-wide"
          >
            {t('contact')}
          </a>
          <LanguageToggle />
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-2xl"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          &#9776;
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-black text-white w-full py-4 px-6">
          <div className="flex flex-col space-y-4">
            <a
              href="#about"
              className="hover:text-yellow-400 transition font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('about')}
            </a>
            <a
              href="#coaching"
              className="hover:text-yellow-400 transition font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('coaching')}
            </a>
            <a
              href="#speaking"
              className="hover:text-yellow-400 transition font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('speaking')}
            </a>
            <a
              href="#testimonials"
              className="hover:text-yellow-400 transition font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('testimonials')}
            </a>
            <a
              href="#contact"
              className="hover:text-yellow-400 transition font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {t('contact')}
            </a>
            <div className="pt-2 border-t border-white/10 mt-2">
              <LanguageToggle />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
